export const obfuscateToken = (code: string, token?: string): string => {
  if (!token) return code;
  const obfuscatedToken = `${token.slice(0, 5)}${'*'.repeat(5)}`;
  return code.replace(token, obfuscatedToken);
};
